module.exports = __webpack_public_path__ + "img/diamond-animation-mobile.bfa77f6c.png";